export enum PERIOD {
    MONTHLY = 'M',
    YEARLY = 'A',
}